import fetch from 'isomorphic-fetch';

let ENDPOINT_URL = process.env.VUE_APP_APERTURAR_NUEVA_PROGRAMACION;
async function newProgramming(date, obs) {
  const bodyParams = {
    fecha_programacion: date,
    token: localStorage.getItem('token'),
    observaciones: obs,
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { newProgramming };
